export class AppConfig {
  public static SERVER_URL = '';
}